/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { Component } from 'react';
// material
import { SearchBar, SelectField } from '@insticator/insticator-ui'; // iui-material
import ImageTypes from 'material/embeds/imageapi/controller/imagetypes/imagetypes';
// styles
import injectSheet from 'react-jss';
import styles from 'material/embeds/imageapi/controller/controller_styles';



/* ========== ~~~~~~~~~~ IMAGE API : CONTROLLER ~~~~~~~~~~ ========== */
class Controller extends Component {
    constructor(props) {
        super(props);
    };

    handleChange = (e) => this.props.tabSelect(e.target.value);

    render() {
        return (
            <div className={`controls ${this.props.classes.controls}`}>
                <div className={`innerControls`}>
                    {/* wide view */}
                    <ImageTypes selectAction={this.props.tabSelect} selected={this.props.tab} options={[
                        { name:'images', text:'Images' },
                        { name:'giphy', text:'Giphy' },
                        { name:'yourOwn', text:'Your Own' }
                    ]}/>

                    {/* thinner view */}
                    <SelectField type={`select`} name={`imagetype`} defaultValue={this.props.tab} handleChange={this.handleChange} options={[
                        { name:'images', value:'images', text:'Images' },
                        { name:'giphy', value:'giphy', text:'Giphy' },
                        { name:'yourOwn', value:'yourOwn', text:'Your Own' }
                    ]} />

                    {/* search bar */}
                    {this.props.tab !== 'yourOwn' ? <SearchBar placeholder={`Search ...`} onChange={e => this.props.saveSearchTerm(e)} /> : null}
                </div>
            </div>
        )
    };
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(Controller);
